import {
    DELEGATEE_UPDATED,
    DELEGATOR_UPDATED,
    PROFILE_UPDATED,
    UPDATE_DELEGATEES_RESPONSE,
    UPDATE_PROFILE_ERROR,
    USER_UPDATED
} from "./actionTypes";

const authUser = JSON.parse(localStorage.getItem("authUser"));
const initialState = {
    user: authUser,
    profile: null,
    delegators: null,
    delegatees: null,
    delegateesResponse: null,
    profileSuccess: false,
    profileLoading: true,
    profileError: null
};

const user = (state = initialState, action) => {
    switch (action.type) {
        case USER_UPDATED:
            state = {
                ...state,
                user: action.payload
            };
            break;
        case PROFILE_UPDATED:
            state = {
                ...state,
                profile: action.payload,
                profileSuccess: true,
                profileLoading: false,
                profileError: null
            };
            break;
        case UPDATE_PROFILE_ERROR:
            state = {
                ...state,
                profileSuccess: false,
                profileLoading: false,
                profileError: action.payload
            };
            break;
        case DELEGATOR_UPDATED:
            state = {
                ...state,
                delegators: action.payload,
            };
            break;
        case DELEGATEE_UPDATED:
            state = {
                ...state,
                delegatees: action.payload,
            };
            break;
        case UPDATE_DELEGATEES_RESPONSE:
            state = {
                ...state,
                delegateesResponse: action.payload
            };
            break;
        default:
            state = {...state};
            break;
    }
    return state;
};

export default user;
